import { Session } from '@/types';
import { DailyLogProps } from './index';
import { decimalToTime, fmtHrs } from '@/lib/time';

export type UseHooksParams = DailyLogProps;

interface DailyGroup {
  date: string;
  sessionsList: { inStr: string; outStr: string }[];
  totalHoursStr: string;
  status?: string;
}

export const useHooks = ({ sessions, dayMap, overrides = {} }: UseHooksParams) => {
  const groups: Record<string, Session[]> = {};
  for (const session of sessions) {
    if (!groups[session.date]) {
      groups[session.date] = [];
    }
    groups[session.date].push(session);
  }

  const logItems: DailyGroup[] = Object.keys(dayMap)
    .sort((a, b) => b.localeCompare(a)) // Newest date first
    .map((date) => {
      const dateSessions = groups[date] ? groups[date].sort((a, b) => a.in - b.in) : [];
      
      const sessionsList = dateSessions.map((s) => ({
        inStr: decimalToTime(s.in),
        outStr: decimalToTime(s.out)
      }));

      const totalHrs = dayMap[date] || 0;
      const status = overrides[date]?.status || '';

      return {
        date,
        sessionsList,
        totalHoursStr: fmtHrs(totalHrs),
        status
      };
    });

  return {
    logItems
  };
};

